<div>
  
  <button class="cta cta--primary" 
    [ngClass]="{'ticket-win-history': ticketWinHistory}"
    (click)="onButtonClick($event)" 
    [disabled]="disable" #confirmButton>
      <div *ngIf="showSpinner" class="purchase-progress-spinner"></div>
      {{label}}
  </button>
</div>